import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export type OfferListSort = keyof typeof OfferListSortEnum
export const OfferListSortEnum = {
  LABORATORY: {
    label: "Laboratoires",
    sort: "laboratory",
    direction: "asc",
  },
  RECENT: {
    label: "Plus récentes",
    sort: "startDate",
    direction: "desc",
  },
  OLD: {
    label: "Plus anciennes",
    sort: "startDate",
    direction: "asc",
  },
} as const satisfies ReferentialEnum<{
  sort: string
  direction: string
}>

export const offerListSortReferential =
  referentialEnumToReferentialCodeList(OfferListSortEnum)

export const OfferListValidityFilterEnum = {
  LAST_DAYS: {
    label: "Expire dans 7 jours",
  },
  LAST_MONTH: {
    label: "Expire dans 30 jours",
  },
} as const satisfies ReferentialEnum
export const offerListValidityFilterReferential =
  referentialEnumToReferentialCodeList(OfferListValidityFilterEnum)
